/**
 * Lexicographic order by UTF-16 code units (same as `<` on strings). Locale-invariant across runtimes.
 */
export const compareStringsUtf16 = (a: string, b: string): number => {
  if (a < b) {
    return -1;
  }
  if (a > b) {
    return 1;
  }
  return 0;
};
